import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { RouterParamType } from "@/model/navModel";
import { usePurchaseRoDetailsModel, ISCMPRoDescType } from "../scmPurchaseRoModel";
import { formatNum } from "@/utils/utils";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { lookDesc } = usePurchaseRoDetailsModel();
    const { cm } = useGlobalModel();

    const retuenText = (field: string, money: boolean = false) => {
        let desc: ISCMPRoDescType = lookDesc
        return money ? `￥${formatNum(desc[field])}` : desc[field];
    }

    const orderStatistics: IDescription[] = [
        {
            label: "开单量",
            value: retuenText("numAll"),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "种类",
            value: retuenText("kindAll"),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "确认",
            value: retuenText("stockInAll"),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "驳回",
            value: retuenText("rejectAll"),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "总计",
            value: retuenText("amountAll", true),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "出库总计",
            value: retuenText("settleAmountAll", true),
            color: DescriptionColorEnum.red,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}